import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';
import { secondsToTimeDurationString } from '..';

export const runTimeColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
): TableColumn<T> => ({
  id: 'runTime',
  label: <Trans i18nKey="run_time" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">
      {secondsToTimeDurationString(value)}
    </div>
  ),
  acessorKey: 'runTime',
  sortable: false,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
